<template>
  <div class="questionnaire">
    <!-- 问卷列表 -->
    <Spin fix v-if="showNoData"></Spin>
    <div
      class="caring-cover"
      style="z-index:3"
      v-if="(showCover && !showNoData) || type === 'model'"
    ></div>
    <div v-if="!showNoData" class="mquestionaire" style="width: 100%;">
      <div class="mquestionaire_content">
        <div v-for="(_item,_index) in allQuestionList" :key="_index">
          <!-- 所有选项     :questionnaireId="questionnaire.id"    -->
          <questionnaireItem
            v-if="_item.type != 'module'"
            :item="_item"
            :pindex="_index"
            @radiootherPrompt="radiootherPrompt"
            @checkboxDate="checkboxDate"
            @scaleDate="scaleDate"
            @selectDate="selectDate"
            :questionIsAnswer="questionIsAnswer"
          ></questionnaireItem>
          <!-- 是否有模块 -->
          <div v-if="questionnaireHas && _item.type == 'module'" class="questionaire_model">
            <div class="model_nav">
              <div class="model_title">{{_item.name}}</div>
              <div class="model_info">{{_item.prompt}}</div>
            </div>

            <div v-for="(i, inx) in  _item.questiontitle" :key="inx" style="padding: 0 20px;">
              <questionnaireItem
                :item="i"
                :pindex="inx"
                @radiootherPrompt="radiootherPrompt"
                @checkboxDate="checkboxDate"
                @scaleDate="scaleDate"
                @selectDate="selectDate"
                :questionIsAnswer="questionIsAnswer"
              ></questionnaireItem>
            </div>
          </div>
        </div>
      </div>
      <!-- <Button
        :disabled="disabledBtn"
          @click="submitbtn"
      >提交</Button>-->
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import questionnaireItem from './question-item'
export default {
  name: 'questionnaire',
  props: ['questId', 'uniqueId', 'showCover', 'type', 'modelData'],
  // props: {
  //   questId: {
  //     type: String,
  //     default: "",
  //   },
  //   uniqueId:{
  //     type: String,
  //     default: "",
  //   },
  //   showCover: {
  //     type: Boolean,
  //     default: false
  //   },
  //   type: {
  //     type: String,
  //     default: ""
  //   },
  //   modelData: {
  //     type: Object,
  //     default: () => ({})
  //   },
  //   footer: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  data() {
    return {
      // 所以的问卷信息
      questionnaire: {},
      questionnaireModules: [],
      questionnaireHas: false,
      data: '',
      disabledBtn: false,
      loading: false,
      elasticFrame: false,
      // 提交答案
      answer: {
        username: '',
        password: '',
        questionnaireId: '',
        answers: [],
      },
      // 问卷错误标记
      submitSpot: true,
      // name: "",
      // 问卷的id
      userPermission: 'all',
      // 修改问卷的次数
      disabledIndex: 0,
      password: '',
      showData: false,
      // 现在时间
      nowDate: '',
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      openAtFixedTime: false,
      uniqueIdAnswer: '',
      showNoData: true,
      Verification: true, //通过v-show控制显示获取还是倒计时
      timer: 60, //定义初始时间为60s
      getVerify: '',
      getPhoneVerify: '',
      ceshi: 0,
      scrollHeight: 0,
      clientHeight: 0,
      offsetHeight: 0,
      marginTop: false,
      ceshiName: '',
      allQuestionList: [],
      uniqueIdFlag: false,
      modelChangeData: '',
      flag: true,
      questionIsAnswer: false,
    }
  },

  mounted: function () {
    this.init()
  },
  watch: {
    // 监听到数据然后赋值
    questId(newV, oldV) {
      this.questId = newV
      this.$emit('change')
      this.init()
    },
    uniqueId(newVal) {
      if (!newVal) {
        this.uniqueIdFlag = false
      }
      this.$emit('change')
      // this.questId = newV
      this.init()
    },
  },

  methods: {
    init: function () {
      if (!this.type || this.type !== 'model') {
        if (this.questId || this.$route.query.questId) {
          this.$store.commit(
            'changequestId',
            this.$route.query.questId || this.questId
          )
          if (this.uniqueId || this.$route.query.uniqueId) {
            this.$store.commit(
              'setUniqueId',
              this.$route.query.uniqueId || this.uniqueId
            )
            this.getUniqued()
          } else {
            this.uniqueIdAnswer = []
            this.questionIsAnswer = false
            this.getQuestionaire()
          }
        }
      } else {
        this.modelChangeData = JSON.parse(JSON.stringify(this.modelData))
        if (
          this.modelChangeData.questions.length === 0 &&
          this.modelChangeData.moduleResponse.has === false
        ) {
          this.showNoData = true
          return
        } else {
          this.showNoData = false
        }
        // if (this.modelChangeData.questionnaire.recycle == false) {
        //   this.$Message.warning('问卷暂未回收，只能查看不能提交')
        // }
        this.data = this.modelChangeData

        // 验证填写者身份
        this.$store.commit(
          'changeuserPermission',
          this.modelChangeData.questionnaire.questionnaireAttribute
            .userPermission
        )
        // 问卷填写密码
        this.$store.commit(
          'setpassword',
          this.modelChangeData.questionnaire.questionnaireAttribute.password
        )
        // 开始和结束时间
        this.endDate = new Date(
          this.modelChangeData.questionnaire.questionnaireAttribute.endDate
        ).getTime()
        this.startDate = new Date(
          this.modelChangeData.questionnaire.questionnaireAttribute.startDate
        ).getTime()
        // 允许填写者在登录后修改
        // this.$store.state.modifyWhenLogin =
        //   this.modelChangeData.questionnaire.questionnaireAttribute.modifyWhenLogin
        // 是否需要提交时验证码
        this.$store.state.needVerificationCodeWhenSubmit =
          this.modelChangeData.questionnaire.questionnaireAttribute.needVerificationCodeWhenSubmit
        // console.log(this.$store.state.needVerificationCodeWhenSubmit)
        //  是否需要分享
        this.$store.state.showQRCode =
          this.modelChangeData.questionnaire.questionnaireAttribute.showQRCode

        // 判断是暂停回收还是开始回收collectStatus
        this.$store.state.recycle = this.modelChangeData.questionnaire.recycle
        // 每日开启时段修改时间
        if (
          this.modelChangeData.questionnaire.questionnaireAttribute
            .startAndEndTimes.length > 0
        ) {
          this.modelChangeData.questionnaire.questionnaireAttribute.startAndEndTimes.forEach(
            (_item, _index) => {
              _item.endTime =
                String(new Date().getFullYear()) +
                '-' +
                String(new Date().getMonth() + 1) +
                '-' +
                String(new Date().getDate()) +
                ' ' +
                _item.endTime
              _item.startTime =
                String(new Date().getFullYear()) +
                '-' +
                String(new Date().getMonth() + 1) +
                '-' +
                String(new Date().getDate()) +
                ' ' +
                _item.startTime
              //  存在范围内
              if (
                this.nowDate < Date.parse(_item.endTime) &&
                this.nowDate > Date.parse(_item.startTime)
              ) {
                this.openAtFixedTime = true
              }
            }
          )
        }
        // 判断开启时间和结束时间
        if (
          this.modelChangeData.questionnaire.questionnaireAttribute
            .hasStartEndDate == true &&
          this.endDate &&
          this.startDate &&
          (this.nowDate > this.endDate || this.nowDate < this.startDate)
        ) {
          this.$router.push({
            name: 'startEnd',
            params: {
              type: 'hasStartEndDate',
            },
          })
        } else {
          if (
            this.modelChangeData.questionnaire.questionnaireAttribute
              .openAtFixedTime == true &&
            this.openAtFixedTime == false
          ) {
            this.$router.push({
              name: 'startEnd',
              params: {
                type: 'openAtFixedTime',
              },
            })
          }
        }
        if (this.modelChangeData) {
          this.setData(this.$store.state.password, this.data)
        }
      }
      this.$store.commit('setShareUrl', location.href)
      // 获取现在时间的毫秒值
      this.nowDate = Date.now()
      // 获取app或微信中的用户
      this.answer.username =
        this.$store.state.username || localStorage.getItem('username') || ''

      this.answer.questionnaireId = this.$store.state.questionnaireId
    },
    // 判断问卷是否已经填写过，填写过只能查看答案
    getUniqued: function () {
      this.uniqueIdAnswer = []
      this.$store.state.uniqueIdAnswer = false
      axios({
        method: 'GET',
        contentType: 'application/json;charset=utf-8',
        headers: {
          tenant: this.$store.state.tenant.tenant,
        },
        url:
          this.$store.state.INTERFACE.GET_UNIQUE_QUEST +
          '/' +
          (this.questId || this.$route.query.questId) +
          '/' +
          (this.uniqueId || this.$route.query.uniqueId),
      })
        .then((res) => {
          if (res.data.code === 0) {
            // console.log(res.data.data)
            this.uniqueIdFlag = true
            this.questionIsAnswer = true
            if (res.data.data.answers) {
              this.uniqueIdAnswer = res.data.data.answers
            }
            this.$emit('uniqued-result', res.data)
          }
          this.getQuestionaire()
        })
        .catch(function (error) {})
    },
    // 获取问卷信息
    getQuestionaire: function () {
      this.allQuestionList = []
      axios({
        method: 'GET',
        contentType: 'application/json;charset=utf-8',
        headers: {
          tenant: this.$store.state.tenant.tenant,
        },
        url:
          this.$store.state.INTERFACE.GET_QUEST +
          '/' +
          (this.questId || this.$route.query.questId),
      })
        .then((res) => {
          if (res.data.code === 0) {
            if (
              res.data.data.questions.length === 0 &&
              res.data.data.moduleResponse.has === false
            ) {
              this.showNoData = true
              return
            } else {
              this.showNoData = false
            }
            // if (res.data.data.questionnaire.recycle == false) {
            //   this.$Message.warning('问卷暂未回收，只能查看不能提交')
            // }
            this.data = res.data.data
            this.$emit('init')
            // 验证填写者身份
            this.$store.commit(
              'changeuserPermission',
              res.data.data.questionnaire.questionnaireAttribute.userPermission
            )
            // 问卷填写密码
            this.$store.commit(
              'setpassword',
              res.data.data.questionnaire.questionnaireAttribute.password
            )
            // 开始和结束时间
            this.endDate = new Date(
              res.data.data.questionnaire.questionnaireAttribute.endDate
            ).getTime()
            this.startDate = new Date(
              res.data.data.questionnaire.questionnaireAttribute.startDate
            ).getTime()
            // 允许填写者在登录后修改
            // this.$store.state.modifyWhenLogin =
            //   res.data.data.questionnaire.questionnaireAttribute.modifyWhenLogin
            // 是否需要提交时验证码
            this.$store.state.needVerificationCodeWhenSubmit =
              res.data.data.questionnaire.questionnaireAttribute.needVerificationCodeWhenSubmit
            // console.log(this.$store.state.needVerificationCodeWhenSubmit)
            //  是否需要分享
            this.$store.state.showQRCode =
              res.data.data.questionnaire.questionnaireAttribute.showQRCode

            // 判断是暂停回收还是开始回收collectStatus
            this.$store.state.recycle = res.data.data.questionnaire.recycle
            // 每日开启时段修改时间
            if (
              res.data.data.questionnaire.questionnaireAttribute
                .startAndEndTimes.length > 0
            ) {
              res.data.data.questionnaire.questionnaireAttribute.startAndEndTimes.forEach(
                (_item, _index) => {
                  _item.endTime =
                    String(new Date().getFullYear()) +
                    '-' +
                    String(new Date().getMonth() + 1) +
                    '-' +
                    String(new Date().getDate()) +
                    ' ' +
                    _item.endTime
                  _item.startTime =
                    String(new Date().getFullYear()) +
                    '-' +
                    String(new Date().getMonth() + 1) +
                    '-' +
                    String(new Date().getDate()) +
                    ' ' +
                    _item.startTime
                  //  存在范围内
                  if (
                    this.nowDate < Date.parse(_item.endTime) &&
                    this.nowDate > Date.parse(_item.startTime)
                  ) {
                    this.openAtFixedTime = true
                  }
                }
              )
            }
            // 判断开启时间和结束时间
            if (
              res.data.data.questionnaire.questionnaireAttribute
                .hasStartEndDate == true &&
              this.endDate &&
              this.startDate &&
              (this.nowDate > this.endDate || this.nowDate < this.startDate)
            ) {
              this.$router.push({
                name: 'startEnd',
                params: {
                  type: 'hasStartEndDate',
                },
              })
            } else {
              if (
                res.data.data.questionnaire.questionnaireAttribute
                  .openAtFixedTime == true &&
                this.openAtFixedTime == false
              ) {
                this.$router.push({
                  name: 'startEnd',
                  params: {
                    type: 'openAtFixedTime',
                  },
                })
              }
            }
            if (res.data.data) {
              this.setData(this.$store.state.password, this.data)
            }
          }
        })
        .catch(function (error) {})
    },
    // 根据realIndex排序
    compare(realIndex) {
      return function (obj1, obj2) {
        var value1 = obj1[realIndex]
        var value2 = obj2[realIndex]
        return value1 - value2
      }
    },

    // 修改问卷数据
    setData: function (setPassword, data) {
      // if (setPassword.trim() == this.password.trim() || this.type === 'model') {
      this.showData = true
      // 判断题目的数量
      var indexAll = 0
      indexAll = data.questions.length

      this.$store.state.questionnaireIndex = indexAll
      // 问卷名称
      this.$store.state.questionnaireName =
        data.questionnaire.questionnaireAttribute.name
      this.questionnaireName = data.questionnaire.questionnaireAttribute.name
      // 问卷说明
      this.$store.state.questionnairePrompt =
        data.questionnaire.questionnaireAttribute.prompt
      // 模块问卷
      if (this.type === 'model') {
        this.questionnaireModules = data.moduleRequest.modules
        if (data.moduleRequest.modules.length > 0) {
          data.moduleRequest.modules.forEach((_item) => {
            _item.type = 'module'
          })
        }
        this.allQuestionList = data.moduleRequest.modules

        this.questionnaireHas = data.moduleRequest.has
      } else {
        this.questionnaireModules = data.moduleResponse.modules
        if (data.moduleResponse.modules.length > 0) {
          data.moduleResponse.modules.forEach((_item) => {
            _item.type = 'module'
          })
        }
        this.allQuestionList = data.moduleResponse.modules

        this.questionnaireHas = data.moduleResponse.has
      }

      // 问卷id
      // 复制题目
      this.answer.questionnaireId = data.questionnaire.id
      this.$store.state.questionnaireId = data.questionnaire.id
      if (data.questions.length > 0 && this.uniqueIdAnswer === '') {
        data = this.dataDeal(data)
        data.questions.forEach((item, index) => {
          this.$set(item, 'pindex', index)
        })
        data.questions.forEach((item) => {
          if (item.value.innerOrder == '') {
            this.allQuestionList.push(item)
          }
        })

        this.questionsMake(data.questions)
        this.allQuestionList.forEach((item) => {
          if (item.type == 'module') {
            if (item.questiontitle) {
              this.questionsMake(item.questiontitle)
            } else {
              this.questionsMake(item.questionList)
            }
          }
        })
      } else if (data.questions && this.uniqueIdAnswer !== '') {
        this.questionsMake(data.questions)
        this.allQuestionList.forEach((item) => {
          if (item.type == 'module') {
            if (item.questiontitle) {
              this.questionsMake(item.questiontitle)
            } else {
              this.questionsMake(item.questionList)
            }
          }
        })
        // 将答案放到answer属性中
        this.fillAnswer(data.questions, this.uniqueIdAnswer)
        // 将数据拼接
        data = this.dataDeal(data)
        // 给题目设置一个index
        data.questions.forEach((item, index) => {
          this.$set(item, 'pindex', index)
        })
        // 根据realIndex进行排序
        data.questions.forEach((item) => {
          if (item.value.innerOrder == '') {
            this.allQuestionList.push(item)
          }
        })
      }
      this.$store.state.questionnaire = this.allQuestionList

      // } else {
      //   // 填写密码
      //   // this.showPrompt();
      // }
    },

    // 修改模板问卷数据
    dataDeal: function (data) {
      const questMain = data.questions
      const deleteIndex = []
      if (this.type === 'model') {
        var moduleQuest = data.moduleRequest.modules
      } else {
        var moduleQuest = data.moduleResponse.modules
      }
      moduleQuest.map((item) => {
        this.$set(item, 'questiontitle', [])
        questMain.map((i, index) => {
          // 被循环了两次

          if (item.questionIds.indexOf(i.value.id) > -1) {
            deleteIndex.push(index)
            item.questiontitle.push(i)
          }
        })
      })
      // 将删除的index从小到大排序
      var newDeleteIndex = deleteIndex.sort(function (x, y) {
        return x - y
      })
      newDeleteIndex.reverse().map((item) => {
        questMain.splice(item, 1)
      })
      return data
    },

    // 给每个题目添加一个answer属性来获取选中的值 （单选多选下拉量表在选项中设置默认值）和一个验证状态信息
    questionsMake: function (data) {
      if (data != undefined) {
        data = data.map((item) => {
          if (item.type == 'DropDownQuestion') {
            item.value.dropDownAttribute.answer =
              item.value.dropDownAttribute.defaultValue || ''
            item.value.dropDownAttribute.verifyStatus = true
          } else if (item.type == 'MultipleLineTextQuestion') {
            item.value.multipleLineTextAttribute.answer =
              item.value.multipleLineTextAttribute.defaultValue || ''
            item.value.multipleLineTextAttribute.verifyStatus = true
          } else if (item.type == 'SingleLineTextQuestion') {
            item.value.singleLineTextAttribute.answer =
              item.value.singleLineTextAttribute.defaultValue || ''
            item.value.singleLineTextAttribute.verifyStatus = true
          } else if (item.type == 'DigitalQuestion') {
            item.value.digitalAttribute.answer =
              item.value.digitalAttribute.defaultValue || 0
            item.value.digitalAttribute.verifyStatus = true
          } else if (item.type == 'RateQuestion') {
            // item.value.rateAttribute.answer = 0;
            this.$set(
              item.value.rateAttribute,
              'answer',
              Number(item.value.rateAttribute.defaultValue) || 0
            )
            this.$set(item.value.rateAttribute, 'verifyStatus', true)
          } else if (item.type == 'FileUploadQuestion') {
            item.value.fileUploadAttribute.answer =
              item.value.fileUploadAttribute.defaultValue || []
            item.value.fileUploadAttribute.verifyStatus = true
          } else if (item.type == 'DateQuestion') {
            // console.log(item)
            this.$set(
              item.value.dateAttribute,
              'answer',
              item.value.dateAttribute.defaultValue || ''
            )
            this.$set(item.value.dateAttribute, 'verifyStatus', true)
          } else if (item.type == 'TimeQuestion') {
            // console.log(item)
            this.$set(
              item.value.timeAttribute,
              'answer',
              item.value.timeAttribute.defaultValue || ''
            )
            this.$set(item.value.timeAttribute, 'verifyStatus', true)
          } else if (item.type == 'DateTimeQuestion') {
            // console.log(item)
            this.$set(
              item.value.dateTimeAttribute,
              'answer',
              item.value.dateTimeAttribute.defaultValue || ''
            )
            this.$set(item.value.dateTimeAttribute, 'verifyStatus', true)
          } else if (item.type == 'SingleChoiceQuestion') {
            item.value.singleChoiceAttribute.answer = ''
            this.Radiovalue = item.value.singleChoiceAttribute.answer
            item.value.singleChoiceAttribute.verifyStatus = true
          } else if (item.type == 'MultipleChoiceQuestion') {
            this.$set(item.value.multipleChoiceAttribute, 'answer', [])
            this.$set(item.value.multipleChoiceAttribute, 'verifyStatus', true)
          } else if (item.type == 'ScaleQuestion') {
            item.value.scaleAttribute.answer =
              item.value.scaleAttribute.defaultValue || 0
            item.value.scaleAttribute.verifyStatus = true
          } else if (item.type == 'FillInBlankQuestion') {
            this.$set(item.value.fillInBlanksAttribute, 'answer', [])
            this.$set(item.value.fillInBlanksAttribute, 'verifyStatus', true)
          } else if (item.type == 'SliderQuestion') {
            this.$set(item.value.sliderAttribute, 'answer', '')
            this.$set(item.value.sliderAttribute, 'verifyStatus', true)
          } else if (item.type == 'TableQuestion') {
            this.$set(item.value.tableAttribute, 'answer', [])
            this.$set(item.value.tableAttribute, 'verifyStatus', true)
          }
          return item
        })
      }
    },
    // 有答案默认填充
    fillAnswer: function (questions, uniqueIdAnswer) {
      if (questions.length > 0) {
        uniqueIdAnswer.forEach((_item) => {
          questions.forEach((item) => {
            if (item.value.id === _item.questionId) {
              //  item.value.uniqueIdAnswer = _item.value
              if (item.type == 'DropDownQuestion') {
                item.value.dropDownAttribute.answer =
                  _item.value.dropDownOption.name
                item.value.dropDownAttribute.verifyStatus = true
              } else if (item.type == 'MultipleLineTextQuestion') {
                item.value.multipleLineTextAttribute.answer =
                  _item.value.answerString
                item.value.multipleLineTextAttribute.verifyStatus = true
              } else if (item.type == 'SingleLineTextQuestion') {
                item.value.singleLineTextAttribute.answer =
                  _item.value.answerString
                item.value.singleLineTextAttribute.verifyStatus = true
              } else if (item.type == 'DigitalQuestion') {
                // if(_item.value.resultDigital.indexOf('.')> -1) {

                // }
                item.value.digitalAttribute.answer = parseFloat(
                  Number(_item.value.resultDigital)
                )
                item.value.digitalAttribute.verifyStatus = true
                if (_item.value.desc) {
                  item.value.digitalAttribute.desc = _item.value.desc
                  item.value.digitalAttribute.isNormal = _item.value.isNormal
                }
              } else if (item.type == 'RateQuestion') {
                // item.value.rateAttribute.answer = 0;
                this.$set(item.value.rateAttribute, 'answer', _item.value.rate)
                this.$set(item.value.rateAttribute, 'verifyStatus', true)
              } else if (item.type == 'FileUploadQuestion') {
                item.value.fileUploadAttribute.answer = _item.value.imageUrls

                item.value.fileUploadAttribute.verifyStatus = true
              } else if (item.type == 'DateQuestion') {
                // console.log(item)
                this.$set(item.value.dateAttribute, 'answer', _item.value.date)
                this.$set(item.value.dateAttribute, 'verifyStatus', true)
              } else if (item.type == 'TimeQuestion') {
                // console.log(item)
                this.$set(item.value.timeAttribute, 'answer', _item.value.time)
                this.$set(item.value.timeAttribute, 'verifyStatus', true)
              } else if (item.type == 'DateTimeQuestion') {
                // console.log(item)
                this.$set(
                  item.value.dateTimeAttribute,
                  'answer',
                  _item.value.time
                )
                this.$set(item.value.dateTimeAttribute, 'verifyStatus', true)
              } else if (item.type == 'SingleChoiceQuestion') {
                item.value.singleChoiceAttribute.answer =
                  _item.value.singleChoiceOption
                // this.Radiovalue = item.value.singleChoiceAttribute.answer;
                item.value.singleChoiceAttribute.verifyStatus = true
              } else if (item.type == 'MultipleChoiceQuestion') {
                this.$set(
                  item.value.multipleChoiceAttribute,
                  'answer',
                  _item.value.multipleChoiceOptions
                )
                this.$set(
                  item.value.multipleChoiceAttribute,
                  'verifyStatus',
                  true
                )
              } else if (item.type == 'ScaleQuestion') {
                item.value.scaleAttribute.answer = _item.value.resultNumber
                item.value.scaleAttribute.verifyStatus = true
              } else if (item.type == 'FillInBlankQuestion') {
                this.$set(
                  item.value.fillInBlanksAttribute,
                  'answer',
                  _item.value.answerStrings
                )
                this.$set(
                  item.value.fillInBlanksAttribute,
                  'verifyStatus',
                  true
                )
              } else if (item.type == 'SliderQuestion') {
                this.$set(
                  item.value.sliderAttribute,
                  'answer',
                  _item.value.answerString
                )
                this.$set(item.value.sliderAttribute, 'verifyStatus', true)
              } else if (item.type == 'TableQuestion') {
                this.$set(
                  item.value.tableAttribute,
                  'answer',
                  _item.value.answerString
                )
                this.$set(item.value.tableAttribute, 'verifyStatus', true)
              }
              return item
            }
          })
        })
      }
    },
    // 单选
    Radiovalue: function (val) {},
    radiootherPrompt: function (val) {
      // console.log("ceshi:", val);
    },
    // 多选
    checkboxDate: function (val) {
      // console.log("ceshi", val);
    },
    // 量表题
    scaleDate: function (val) {
      // console.log("ceshi", val);
    },
    // 下拉
    selectDate: function (val) {
      // console.log("ceshi.", val);
    },
    // 问卷填写密码
    showPrompt: function () {
      this.$Modal.confirm({
        render: (h) => {
          return h('Input', {
            props: {
              value: '',
              autofocus: true,
              placeholder: '请填写问卷密码',
            },
            on: {
              input: (val) => {
                if (val == this.$store.state.password) {
                  this.password = val

                  this.$nextTick(() => {
                    this.password = val
                  })
                  this.$Message.warning('密码输入正确')
                  // console.log(this.nowDate)
                  this.setData(this.$store.state.password, this.data)
                } else {
                  this.$Message.warning('密码输入错误')
                  // this.setData(this.$store.state.password, this.data)
                }
              },
            },
          })
        },
      })
    },
    preFix: function (info, decima) {
      // console.log(decima);
      // 判断是否有小数点
      var dot = info.toString().indexOf('.')
      // console.log(dot)
      var num = 0
      // 有小数点
      if (info) {
        if (dot > -1) {
          // 判断有几位小数点
          num = info.toString().split('.')[1].length

          if (Number(num) !== Number(decima)) {
            // console.log(Number(num));
            // console.log(Number(decima));
            for (var i = 0; i < Number(decima) - Number(num); i++) {
              info = info + '0'
            }
            // console.log(info);
          }
        } else {
          if (decima) {
            info = info + '.'
            for (var i = 0; i < Number(decima); i++) {
              info = info + '0'
            }
          } else {
            info = info
          }
        }
      }
      return info
    },
    // 提交获取答案数据
    submitData: function (item, index, name) {
      this.submitSpot = true
      // const answers =this.answerlist;
      console.log(item)
      //  下拉
      if (item.type === 'DropDownQuestion') {
        if (
          Boolean(item.value.dropDownAttribute.fill) === true &&
          item.value.dropDownAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.dropDownAttribute.verifyStatus === false &&
          item.value.dropDownAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'DropDownAnswer',
            questionId: item.value.id,
            value: {
              dropDownOption: {
                name: item.value.dropDownAttribute.answer,
              },
            },
          }
          this.answer.answers.push(params)
          this.submitSpot = true
        }
      }
      // 多行文本
      if (item.type === 'MultipleLineTextQuestion') {
        // console.log(item.value.multipleLineTextAttribute.answer);
        // console.log(item.value.multipleLineTextAttribute.verifyStatus);
        if (
          Boolean(item.value.multipleLineTextAttribute.fill) === true &&
          item.value.multipleLineTextAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return
        } else if (
          item.value.multipleLineTextAttribute.verifyStatus === false &&
          item.value.multipleLineTextAttribute.answer !== ''
        ) {
          // console.log(this.submitSpot);

          this.submitSpot = false
          return
        } else {
          // console.log(3333);
          const params = {
            type: 'MultipleLineTextAnswer',
            questionId: item.value.id,
            value: {
              answerString: item.value.multipleLineTextAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 单行文本
      if (item.type === 'SingleLineTextQuestion') {
        if (
          Boolean(item.value.singleLineTextAttribute.fill) === true &&
          item.value.singleLineTextAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.singleLineTextAttribute.verifyStatus === false &&
          item.value.singleLineTextAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'SingleLineTextAnswer',
            questionId: item.value.id,
            value: {
              answerString: item.value.singleLineTextAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 数字
      if (item.type === 'DigitalQuestion') {
        //  console.log(item.value.digitalAttribute.verifyStatus)
        //  console.log(item.value.digitalAttribute.answer)
        if (
          Boolean(item.value.digitalAttribute.fill) === true &&
          item.value.digitalAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.digitalAttribute.verifyStatus === false &&
          item.value.digitalAttribute.answer !== ''
        ) {
          // Number(item.value.digitalAttribute.answer) >item.value.digitalAttribute.maxValue
          this.submitSpot = false
          return false
        } else {
          item.value.digitalAttribute.answer = this.preFix(
            item.value.digitalAttribute.answer,
            item.value.digitalAttribute.numberQuantityAfterPoint
          )
          const params = {
            type: 'DigitalAnswer',
            questionId: item.value.id,
            value: {
              resultDigital: item.value.digitalAttribute.answer.toString(),
            },
          }
          this.answer.answers.push(params)
        }
      }
      // 填空题
      if (item.type === 'FillInBlankQuestion') {
        console.log(item)
        // console.log(item.value.fillInBlanksAttribute.answer);
        if (
          Boolean(item.value.fillInBlanksAttribute.fill) == true &&
          item.value.fillInBlanksAttribute.answer.length == '0'
        ) {
          this.flag = false
          this.$Message.warning(
            '请将第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.fillInBlanksAttribute.verifyStatus === false &&
          item.value.fillInBlanksAttribute.answer.length !== 0
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'FillInBlankAnswer',
            questionId: item.value.id,
            value: {
              answerStrings: item.value.fillInBlanksAttribute.answer,
            },
          }
          this.answer.answers.push(params)
          // console.log(this.answer.answers);
        }
      }
      // 评分
      if (item.type === 'RateQuestion') {
        if (
          Boolean(item.value.rateAttribute.fill) == true &&
          item.value.rateAttribute.answer == ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.rateAttribute.verifyStatus === false &&
          item.value.rateAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'RateAnswer',
            questionId: item.value.id,
            value: {
              rate: item.value.rateAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 日期题
      if (item.type === 'DateQuestion') {
        if (
          Boolean(item.value.dateAttribute.fill) === true &&
          item.value.dateAttribute.answer === ''
        ) {
          this.flag = false
          // console.log(index + "daata");
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          // console.log(this.submitSpot);
          return false
        } else if (
          item.value.dateAttribute.verifyStatus === false &&
          item.value.dateAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'DateAnswer',
            questionId: item.value.id,
            value: {
              date: item.value.dateAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // // 时间
      // console.log(item.value.timeAttribute)

      if (item.type === 'TimeQuestion') {
        if (
          Boolean(item.value.timeAttribute.fill) === true &&
          item.value.timeAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.timeAttribute.verifyStatus === false &&
          item.value.timeAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'DateTimeAnswer',
            questionId: item.value.id,
            value: {
              time: item.value.timeAttribute.answer || '',
            },
          }

          this.answer.answers.push(params)
        }
      }
      //  日期时间题
      if (item.type === 'DateTimeQuestion') {
        if (
          Boolean(item.value.dateTimeAttribute.fill) === true &&
          item.value.dateTimeAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.dateTimeAttribute.verifyStatus === false &&
          item.value.dateTimeAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'DateTimeAnswer',
            questionId: item.value.id,
            value: {
              time: item.value.dateTimeAttribute.answer || '',
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 单选题
      if (item.type === 'SingleChoiceQuestion') {
        // console.log(item.value.singleChoiceAttribute.answer)
        if (
          Boolean(item.value.singleChoiceAttribute.fill) === true &&
          item.value.singleChoiceAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.singleChoiceAttribute.verifyStatus === false &&
          item.value.singleChoiceAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'SingleChoiceAnswer',
            questionId: item.value.id,
            value: {
              singleChoiceOption: item.value.singleChoiceAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 多选题
      if (item.type === 'MultipleChoiceQuestion') {
        // console.log(item.value.multipleChoiceAttribute.answer.length);
        if (
          Boolean(item.value.multipleChoiceAttribute.fill) === true &&
          item.value.multipleChoiceAttribute.answer.length === 0
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.multipleChoiceAttribute.verifyStatus === false &&
          item.value.multipleChoiceAttribute.answer.length !== 0
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'MultipleChoiceAnswer',
            questionId: item.value.id,
            value: {
              multipleChoiceOptions: item.value.multipleChoiceAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 文件上传
      if (item.type === 'FileUploadQuestion') {
        if (
          Boolean(item.value.fileUploadAttribute.fill) === true &&
          item.value.fileUploadAttribute.answer.length === 0
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.fileUploadAttribute.verifyStatus === false &&
          item.value.fileUploadAttribute.answer.length !== 0
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'FileUploadAnswer',
            questionId: item.value.id,
            value: {
              imageUrls: item.value.fileUploadAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }
      // 量表题
      if (item.type === 'ScaleQuestion') {
        if (
          Boolean(item.value.scaleAttribute.fill) === true &&
          item.value.scaleAttribute.answer === ''
        ) {
          this.flag = false
          this.$Message.warning(
            '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整'
          )
          this.submitSpot = false
          return false
        } else if (
          item.value.scaleAttribute.verifyStatus === false &&
          item.value.scaleAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'ScaleAnswer',
            questionId: item.value.id,
            value: {
              resultNumber: item.value.scaleAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }

      // 滑块题
      if (item.type === 'SliderQuestion') {
        if (
          Boolean(item.value.sliderAttribute.fill) === true &&
          item.value.sliderAttribute.answer === ''
        ) {
          this.$createToast({
            type: 'warn',
            time: 1000,
            txt: '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整',
          }).show()
          this.submitSpot = false
          return false
        } else if (
          item.value.sliderAttribute.verifyStatus === false &&
          item.value.sliderAttribute.answer !== ''
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'SliderAnswer',
            questionId: item.value.id,
            value: {
              answerString: item.value.sliderAttribute.answer,
            },
          }

          this.answer.answers.push(params)
        }
      }

      // 表格题
      if (item.type === 'TableQuestion') {
        let isAnswer = true
        item.value.tableAttribute.answer.forEach((v) => {
          console.log(v)
          v.ques.every((j) => {
            if (j.answer == '') {
              isAnswer = false
              console.log('111')
            }
          })
        })
        // return
        if (Boolean(item.value.tableAttribute.fill) === true && !isAnswer) {
          this.$createToast({
            type: 'warn',
            time: 1000,
            txt: '请将' + name + '第' + (Number(index) + 1) + '题' + '填写完整',
          }).show()
          this.submitSpot = false
          return false
        } else if (
          item.value.tableAttribute.verifyStatus === false &&
          !isAnswer
        ) {
          this.submitSpot = false
          return false
        } else {
          const params = {
            type: 'TableAnswer',
            questionId: item.value.id,
            value: {
              answerString: item.value.tableAttribute.answer,
            },
          }
          this.answer.answers.push(params)
        }
      }
      // console.log(answers);
    },
    // 提交按钮
    submitbtn: function (obj, bizType) {
      console.log('提交', obj, bizType)
      this.answer.username = obj.name || ''
      this.answer.channel = obj.channel || ''
      this.answer.password = this.password
      // if (this.$store.state.recycle == false) {
      //   this.$Message.warning('问卷暂未回收，只能查看不能提交')
      //   this.disabledBtn = true
      //   return
      // }
      this.answer.bizContent = {
        bizType: bizType,
        param: obj,
      }
      this.answer.answers = []
      let allQuestionList_ = this.allQuestionList
      for (var index = 0; index < allQuestionList_.length; index++) {
        if (this.flag) {
          if (allQuestionList_[index].type !== 'module') {
            const name = this.questionnaireName
            this.submitData(allQuestionList_[index], index, name)
          } else {
            allQuestionList_[index].questiontitle.forEach((i, _index) => {
              const moudleName = this.questionnaireName
              if (!this.flag) {
                return
              }
              this.submitData(i, _index, moudleName)
            })
          }
        } else {
          this.flag = true
          return
        }
      }
      // this.allQuestionList.forEach((item, index) => {
      //   if (item.type !== 'module') {
      //     const name = this.$store.state.questionnaireName
      //     this.submitData(item, index, name)
      //   } else {
      //     console.log(item.questionList)
      //     item.questiontitle.forEach((i, _index) => {
      //       const moudleName = this.$store.state.questionnaireName
      //       // console.log(item.name);
      //       this.submitData(i, _index, moudleName)
      //     })
      //   }
      // })

      if (this.submitSpot == false) {
        this.answer.answers = []
      } else if (this.submitSpot == true) {
        // this.$utils.loadingShow()
        // 有unique
        if (this.$store.state.uniqueId) {
          this.answer.uniqueId = this.$store.state.uniqueId
          if (this.uniqueId) {
            this.answer.uniqueId = this.uniqueId
          }
        } else if (this.$store.state.answerId) {
          this.answer.id = this.$store.state.answerId
        }
        // 修改答案页面
        console.log(this.uniqueIdAnswer)

        if (this.uniqueIdFlag === true) {
          console.log('edit')
          axios({
            method: 'PUT',
            url:  this.$store.state.INTERFACE.GET_UNIQUE_QUEST,
            contentType: 'application/json;charset=utf-8',
            headers: {
              tenant: this.$store.state.tenant.tenant,
            },
            data: this.answer,
          })
            .then((res) => {
              // this.$utils.loadingHide()
              if (res.data.code == 0) {
                this.$emit('doPlan', res)
                this.$emit('success', res)
                this.questionIsAnswer = true
                // this.$Message.warning(this.questEditStatus === 'save' ? '保存成功' : '提交成功')
              } else {
                this.$emit('error')
                this.$Message.warning(res.data.message)
              }
            })
            .catch(function (error) {
              this.$emit('error')
              // this.$utils.loadingHide()
              // console.log(error);
            })
        } else {
          console.log('first')
          // if (this.answer.answers.length == 0) {
          //   this.$Message.warning('请填写问卷')
          //   alert('')
          //   return
          // }
          // 提交答案
          axios({
            method: 'POST',
            url: this.uniqueId
              ? this.$store.state.INTERFACE.GET_UNIQUE_QUEST
              : this.$store.state.INTERFACE.GET_UNIQUE,
            contentType: 'application/json;charset=utf-8',
            headers: {
              tenant: this.$store.state.tenant.tenant,
            },
            data: this.answer,
          })
            .then((res) => {
              //  this.$utils.loadingHide()
              if (res.data.code == 0) {
                // this.$emit('doPlan', res)
                this.$emit('success', res)
                this.questionIsAnswer = true
                this.uniqueIdFlag = true
                // 问卷答案id
                this.$store.state.answerId = res.data.data.id
                // console.log(res.data.data)
                // this.$Message.warning(this.questEditStatus === 'save' ? '保存成功' : '提交成功')
                // 判断是否需要修改问卷
                this.disabledBtn = true
              } else {
                this.$Message.warning(res.data.message)
              }
            })
            .catch(function (error) {
              // this.$utils.loadingHide()
              console.log(error)
            })
        }
      }
    },
  },
  components: {
    // questionnaireMain,
    questionnaireItem,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.questionnaire {
  /* height: 500px; */
  position: relative;
  overflow: hidden;
}
.questionnaire .caring-cover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  /* background-color: rgba(147, 147, 147, 0.2); */
}
.ivu-card {
  background-color: transparent !important;
}
.mquestionaire {
  padding: 0 20px;
  width: 100%;
  color: #566277;
  box-sizing: border-box;
  font-size: 14px;
}
/* .mquestionaire .cube-popup .cube-popup_mask .cube-picker {

} */
.mquestionaire .border-bottom-1px:after {
  border: none;
}
.questionnaire .questPassword {
  position: absolute;
  left: 35%;
  border: none;
  background-color: #fff;
  outline: none;
  padding: 20px;
  text-align: center;
  height: 40px;
  line-height: 5px;
  background-color: rgb(66, 134, 241);
  color: #fff;
  border-radius: 5px;
  top: 50px;
}
.mquestionaire .verificateTrue {
  margin-left: 10%;
}
.mquestionaire .verificate {
  margin-left: 5%;
}
.mquestionaire .verificate button {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
  background-color: rgb(66, 134, 241);
  resize: none;
  outline: none;
}
/* 加载 */
/deep/ .cube-loading-spinners {
  margin: 40px auto !important;
}
/* 标题 */
.mquestionaire_nav {
  text-align: center;
  margin: 10px;
}
.mquestionaire_title {
  width: 100%;
  font-size: 18px !important;
  /* padding: 20px; */
  box-sizing: border-box;
}
.mquestionaire_info {
  width: 100%;
  font-size: 18px;
  padding: 10px;
  box-sizing: border-box;
}

/* 提交按钮 */
.questionairem_submit {
  width: 100%;
  margin: 20px auto 40px;
  background-color: rgb(66, 134, 241);
  color: #fff;
  height: 40px;
  line-height: 0px;
  text-align: center;
  border-radius: 5px;
}
.disabledClass {
  background-color: rgb(226, 232, 243);
  color: #666;
}
.popurTip {
  height: 50px;
  line-height: 50px;
  width: 90%;
  text-align: center;
  border-radius: 5px;
  transform: translateX(5%);
  left: 0;
  top: 50%;
  background-color: #ccc;
}
/* 模块样式 */
.questionaire_model {
  width: 100%;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  margin-top: 30px;
  padding: 0;
  box-sizing: border-box;
}
/* 标题栏 */
.questionaire_model .model_nav {
  border-radius: 5px 5px 0 0;
  background-color: rgb(226, 232, 243);
  padding: 20px 0;
}
.model_nav .model_title {
  font-size: 20px;
  line-height: 35px;
  text-align: center;
}
.model_nav .model_info {
  font-size: 18px;
  text-align: center;
}
/* 模块内容 */
.model_content {
  background-color: #fff;
  padding: 20px 5px;
}

/deep/ .questionaire_model .cube-form-field {
  width: 100%;
  padding-bottom: 10px;
}
</style>
